






























import { Component, Vue, Prop, PropSync } from 'vue-property-decorator'
import DatePickerComponent from '@/components/DatePickerComponent.vue'
import DateUtils from '@/utils/DateUtils'

@Component({
  components: {
    DatePickerComponent,
  },
})
export default class DatePickerDialogComponent extends Vue {
  dateUtils = DateUtils.instance

  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  /* タイトル */
  @Prop({ default: "実施日入力" })
  title!: string

  /* 名前 */
  @Prop({ default: "実施日" })
  name!: string

  /** バリデーション */
  invalid = false

  /** 実施日 */
  date = this.dateUtils.getToday()

  /**
   * 初期化
   */
  reset() {
    this.date = this.dateUtils.getToday()
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.date)
    this.reset()
  }

}
